<template>
  <div>
    <div class="outmain ba_f">
      <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>{{ $t('jurisdiction.empower.title') }}</span>
        </div>
      </div>
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item :label="$t('jurisdiction.empower.siteId')">
          <div>{{ form.id }}</div>
        </el-form-item>
        <el-form-item :label="$t('jurisdiction.empower.serviceType')">
          <div>{{ form.service_type }}</div>
        </el-form-item>
        <el-form-item :label="$t('jurisdiction.empower.authStatus')">
          <div>
            <el-tag type="success" v-show="form.status == '1'">{{ $t('jurisdiction.empower.authorized') }}</el-tag>
            <el-tag type="danger" v-show="form.status == '2'">{{ $t('jurisdiction.empower.unauthorized') }}</el-tag>
            <el-tag type="info" v-show="form.status == '3'">{{ $t('jurisdiction.empower.expired') }}</el-tag>
          </div>
        </el-form-item>
        <el-form-item :label="$t('jurisdiction.empower.accountLimit')">
          <div v-if="form.account_type == '2'">{{ form.account_number }}</div>
          <div v-if="form.account_type == '1'">{{ $t('jurisdiction.empower.unlimited') }}</div>
        </el-form-item>
        <el-form-item :label="$t('jurisdiction.empower.siteUrl')">
          <el-input
            auto-complete="off"
            :placeholder="$t('jurisdiction.empower.siteUrlPh')"
            v-model="form.domain_url"
            disabled
            class="elinputs"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('jurisdiction.empower.siteIp')">
          <el-input
            auto-complete="off"
            :placeholder="$t('jurisdiction.empower.siteIpPh')"
            v-model="form.ip_address"
            disabled
            class="elinputs"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('jurisdiction.empower.authCode')">
          <el-input
            auto-complete="off"
            :placeholder="$t('jurisdiction.empower.authCodePh')"
            v-model="form.auth_code"
            disabled
            class="elinputs"
          ></el-input>
          <div class="yb_margin lh16">{{ $t('jurisdiction.empower.authCodeTip') }}</div>
        </el-form-item>
        <el-form-item :label="$t('jurisdiction.empower.expireTime')">
          <el-input
            auto-complete="off"
            :placeholder="$t('jurisdiction.empower.expireTimePh')"
            v-model="form.time_end"
            disabled
            class="elinputs"
            v-if="form.time_type == '2'"
          ></el-input>
          <el-input
            auto-complete="off"
            :placeholder="$t('jurisdiction.empower.unlimited')"
            disabled
            class="elinputs"
            v-if="form.time_type == '1'"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getAuthInfo } from "@/api/set";
export default {
  created() {
    this.bus.$emit("loading", true);
    this.init();
  },
  data() {
    return {
      form: {
        account_number: "",
        account_type: "",
        service_type: "",
        auth_code: "",
        domain_url: "",
        id: "",
        ip_address: "",
        status: "",
        time_end: "",
        time_type: "",
      },
    };
  },
  methods: {
    async init() {
      const { data } = await getAuthInfo();
      this.form2 = this.form;
      this.form = Object.assign(this.form2, data);
      this.bus.$emit("loading", false);
    },
  },
};
</script>
